import React from 'react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { rows } from '../../data/valueComparison';
export function ValueComparison() {
  return <section className="bg-paper py-10 sm:py-14" data-id="element-267" data-mp="wmyp2jlv5yfj">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-268" data-mp="wk2riwdxhbrm">
        <SectionTag icon="⚖️" tone="primary" data-id="element-269" data-mp="10oka4s8jxj0t">
          Comparativa de valor
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-270" data-mp="1oemvyqlvhsqz">
          ¿Cuánto cuesta no tenerlo?
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-3xl px-4 sm:px-6" data-id="element-271" data-mp="1fcx3rik62ps5">
        <ScrollHintTable minWidth="520px" data-id="element-272" data-mp="1fergwap75dlo">
          <table className="w-full text-left text-sm" data-id="element-273" data-mp="1kb8erwm776by">
            <thead data-id="element-274" data-mp="1kduoa1snfvwt">
              <tr className="border-b border-primary/10 bg-primary/5 text-xs uppercase tracking-wide text-primary" data-id="element-275" data-mp="3xi05vxgczo2">
                <th className="px-5 py-3 font-semibold" data-id="element-276" data-mp="8x4cm35gibvt">Sin Enciclopedia</th>
                <th className="px-5 py-3 font-semibold" data-id="element-277" data-mp="ikoksj2zvsez">Con Enciclopedia Pilates 360</th>
              </tr>
            </thead>
            <tbody data-id="element-278" data-mp="dm3hgasg4smb">
              {rows.map((row, i) => <tr key={row.sin} className={i !== rows.length - 1 ? 'border-b border-primary/5' : ''} data-id="element-279" data-mp="dnoblzaum9jn" data-mpi={i}>
                  <td className="bg-white px-5 py-4 align-top text-ink" data-id="element-280" data-mp="sghvry12fdun">{row.sin}</td>
                  <td className="bg-skyblue/40 px-5 py-4 align-top font-medium text-primary" data-id="element-281" data-mp="nlueaj4hbjpk">{row.con}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>

        <p className="mt-6 text-center text-base font-medium text-ink sm:text-lg" data-id="element-282" data-mp="wid2xj5oglgc">
          El lunes puedes improvisar o entrar con todo resuelto. <span className="text-accent" data-id="element-283" data-mp="169poxu4soheg">Tú decides.</span>
        </p>
      </div>
    </section>;
}